import axios from "axios";

export const loadAllCompaniesAPI = (payload) => {
  return axios
    .get(
      `${payload.dataURL}?limit=${payload.pageSize}&countries=[${
        payload.selectedCountries
      }]&admins=[${payload.salesman}]&types=[${
        payload.companyTypesArray
      }]&page=${payload.currentPage}&orderBy=${
        payload.sort ? payload.sort.dir : "desc"
      }&status=${payload.status}&orderColumn=${
        payload.sort ? payload.sort.column : "id"
      }&search=${payload.search ?? ""}`,
      {
        headers: {
          Accept: "application/json",
        },
      }
    )
    .then((res) => res.data);
};

export const loadSingleCompanyAPI = (payload) => {
  return axios
    .get(`/companies/${payload.companyId}`, {
      headers: {
        Accept: "application/json",
      },
    })
    .then((res) => res.data);
};
